import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('delivery_details'),
    fieldAddress: defineMessage('delivery_address'),
    fieldAttentionTo: defineMessage('attention'),
    fieldPhone: defineMessage('phone_1'),
    fieldInstructions: defineMessage('delivery_instructions_1'),
};
